<div class="markdown-container">
  <div class="maincontainer">
    <div class="content {{ project }}" [innerHTML]="content"></div>
  </div>
</div>
